var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// (c) 2023 Acellera Ltd http://www.acellera.com
// All Rights Reserved
// No redistribution in whole or part
//
import { Dialog, DialogContent, TextField, DialogTitle, IconButton, Button, DialogActions, Box, } from "@mui/material";
import { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import DrawIcon from "@mui/icons-material/Draw";
import { KetcherModal } from "../../SharedFormParts/LigandSelector/KetcherModal";
function LoadSMilesDialog({ open, onClose, testCallback, acceptCallback, }) {
    const [fieldContent, setFieldContent] = useState({ value: "", error: "" });
    const handleInputChange = (value) => {
        setFieldContent({
            value,
            error: "",
        });
    };
    const handleAccept = () => __awaiter(this, void 0, void 0, function* () {
        const { success, error } = yield testCallback(fieldContent.value);
        if (!success) {
            const _error = error ? error : "Invalid string.";
            setFieldContent((prev) => {
                return Object.assign(Object.assign({}, prev), { error: _error });
            });
            return;
        }
        acceptCallback(fieldContent.value);
        onClose();
    });
    const disableConfirm = !fieldContent.value || !!fieldContent.error;
    const [openKetcher, setOpenKetcher] = useState(false);
    const openKetcherModal = () => setOpenKetcher(true);
    return (_jsxs(Dialog, Object.assign({ open: open, onClose: onClose }, { children: [_jsxs(DialogTitle, Object.assign({ textAlign: "center" }, { children: ["Load SMILES", _jsx(IconButton, Object.assign({ "aria-label": "close", onClick: onClose, sx: {
                            position: "absolute",
                            right: 4,
                            top: 4,
                        } }, { children: _jsx(CloseIcon, {}) }))] })), _jsx(DialogContent, Object.assign({ sx: { py: 0 } }, { children: _jsxs(Box, Object.assign({ sx: {
                        display: "flex",
                        flexDirection: "row",
                        gap: 1,
                        justifyContent: "center",
                        alignItems: "center",
                    } }, { children: [_jsx(TextField, { fullWidth: true, maxRows: 15, error: !!fieldContent.error, helperText: fieldContent.error, sx: { my: 1 }, label: "SMILES string", variant: "outlined", value: fieldContent.value, size: "small", onChange: (e) => handleInputChange(e.target.value), autoFocus: true, onKeyDown: (e) => {
                                if (e.key === "Enter" && !disableConfirm) {
                                    handleAccept();
                                }
                            } }), _jsx(Button, Object.assign({ variant: "outlined", size: "small", sx: { height: "40px", width: "120px" }, endIcon: _jsx(DrawIcon, {}), onClick: openKetcherModal }, { children: "Draw" }))] })) })), _jsx(DialogActions, Object.assign({ sx: { justifyContent: "center" } }, { children: _jsx(Button, Object.assign({ variant: "contained", disabled: disableConfirm, onClick: handleAccept }, { children: "Confirm" })) })), _jsx(KetcherModal, { open: openKetcher, setOpen: setOpenKetcher, setMolecule: (x) => setFieldContent({ value: x, error: "" }), initialMolecule: fieldContent.value.trim() })] })));
}
export default LoadSMilesDialog;
